import { styled } from '@mui/material/styles';
import Section from './Section';
import { FormattedMessage } from 'react-intl';
import ListItemButton from '@mui/material/ListItemButton';
import Checkbox from '@/components/Checkbox/Checkbox';
import { PartnerTypes } from '@/constants/PartnerTypes';
import { mapConstantsToOptions } from '@/lib/listOptions';

const PartnerType = ({
  value,
  onChange,
  mode = 'light',
}: {
  value: string[];
  onChange: (values: string[]) => void;
  mode?: 'light' | 'dark';
}) => {
  const partnerTypeItems = mapConstantsToOptions(PartnerTypes);

  const handleToggle = (selectedId: string | number) => () => {
    const currentIndex = value.findIndex((v) => v === selectedId);
    const newChecked = [...value];

    if (currentIndex === -1) {
      newChecked.push(selectedId as string);
    } else {
      newChecked.splice(currentIndex, 1);
    }

    onChange(newChecked);
  };

  return (
    <Section
      title={
        <FormattedMessage
          id="partnerType"
          defaultMessage="Partner Type"
        />
      }
      mode={mode}
      defaultOpen={value.length > 0}
    >
      {partnerTypeItems.map(({ id, label }) => (
        <StyledButton key={id} onClick={handleToggle(id)}>
          <StyledCheckbox
            checked={value.includes(id as string)}
            mode={mode}
          />
          <Label>{label}</Label>
        </StyledButton>
      ))}
    </Section>
  );
};

const StyledButton = styled(ListItemButton)({
  padding: '4px 0',
});

const StyledCheckbox = styled(Checkbox)(({ theme }) => ({
  padding: `0 ${theme.spacing(1)} 0 0`,
}));

const Label = styled('div')({
  fontSize: 14,
});

export default PartnerType;
